import React, { useEffect } from 'react';
import './Toast.css';

/**
 * Top-right toast. Auto-hides after `durationMs` (default 5000). Close button included.
 */
const Toast = ({ message, type = 'success', onClose, durationMs = 5000 }) => {
  useEffect(() => {
    if (!message || !onClose) return undefined;
    const id = window.setTimeout(() => onClose(), durationMs);
    return () => window.clearTimeout(id);
  }, [message, onClose, durationMs]);

  if (!message) return null;

  return (
    <div className={`ace-toast ace-toast-${type}`} role="status" aria-live="polite">
      <p className="ace-toast-text">{message}</p>
      <button type="button" className="ace-toast-close" onClick={onClose} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
};

export default Toast;
